<div class="map h-100">
    <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3489.5766004693164!2d77.00699899999996!3d28.999914999999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390dba9c5bcea005%3A0x3b6b0a2f257a4e31!2sHindu%20College%20Of%20Pharmacy%2C%20Sonipat!5e0!3m2!1sen!2sin!4v1737661078601!5m2!1sen!2sin"
        width="100%" height="100%" style="border:0;border-radius: 10px;z-index: 1100;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>